import React, { useState, useEffect } from 'react'
import '../../style/style.css'
import emailTemplatesImage from '../../../../dbJson/MOCK_DATA.json'
import http, { imageURL, URL_S3 } from '../../../../config/BaseUrl'
import { Link, useHistory } from 'react-router-dom'
function EmailTemplate(props) {

  const [template, setTemplate] = useState(null)
  const [submitClose, setSubmitClose] = useState(false)
  const [emailTemplatesImage, setEmailTemplatesImage] = useState([])
  const [myTemplatesImage, setMyTemplatesImage] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchEmailTemplate = async () => {
    try {
      setLoading(true)
      await http.get("event-email-template")
        .then((res) => {
          if (res.data.email_template) {
            setEmailTemplatesImage(res.data.email_template)
            setLoading(false)
          }
        }).catch((err) => {
          setLoading(false)
        })
    } catch (error) {
      setLoading(false)
    }
  }

  const fetchMyTempate = async () => {
    setLoading(true)
    try{
      await http.get('user/saved/email-template')
        .then(res=>{

          const responseData = res.data.data.data
          console.log(responseData)
          let myTemplateData = []
          responseData.forEach(data=>{
            let customData = {
              name: data.name,
              my_template_id: data.id,
              contents: data.contents,
              ...data.email_template
            }

            myTemplateData.push(customData)
          })
          setLoading(false)

          setMyTemplatesImage(myTemplateData)
        })
        .catch(err=>{
          console.log(err)
        })
    }
    catch{

    }
    
  }

  useEffect(() => {
    fetchEmailTemplate()
  }, [])


  const handleSubmit = () => {
    if (template) {
      props.setData(template)
    }
  }

  const changeValue = (item) => {
    setTemplate(item)
    setSubmitClose(true)
  }

  useEffect(() => {
    if (props.hasOwnProperty('oldItem')) {
      if (props.oldItem) {
        let indx = emailTemplatesImage.findIndex(item => item.id == props.oldItem)
        setTemplate(emailTemplatesImage[indx])
      }
    }
  }, [props])


  return (
    <div className="modal fade" id="email-template" tabindex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Select Your Email Template</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">	<span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="modal-tab-header">
              <ul className="mb-3 nav nav-pills justify-content-around" id="email-template-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <span
                    className="tab-item active"
                    id="email-temp-home-tab"
                    href="#email-temp-home"
                    role="tab"
                    data-toggle="tab"
                    aria-controls="email-temp-home"
                    aria-selected="false"
                  >
                    Standard Template
                  </span>
                </li>
                <li className="nav-item" role="presentation">
                  <span
                    className="tab-item"
                    id="email-temp-profile-tab"
                    data-toggle="tab"
                    href="#email-temp-profile"
                    role="tab"
                    aria-controls="email-temp-profile"
                    aria-selected="false"
                    onClick={fetchMyTempate}
                  >
                    My Template
                  </span>
                </li>
              </ul>
            </div>

            <div className="tab-content template-content" id="email-temp-tabContent">
              <div
                className="tab-pane fade show active"
                id="email-temp-home"
                role="tabpanel"
                aria-labelledby="email-temp-home-tab"
              >
                <div className="standared-template">
                  <div className="row">
                    {loading ?
                      <div className="text-center col-md-12">
                        <span className="spinner-border" role="status" aria-hidden="true"></span>
                      </div>
                      : emailTemplatesImage && emailTemplatesImage.map((item) => {
                        return (
                          <div key={item.id} className="my-2 col-md-2">
                            <div className="template-item-body text-center">
                              <div 
                                className={`template-item 
                                  ${template && 'email_my_template_id' in template === false && template.id === item.id ? 'active-template' : ''}`} 
                                onClick={e => changeValue({ id: item.id, image: item.template_image })}>
                                <img src={URL_S3 + 'image/email_template/' + item.template_image} alt="template-1" className="img-fluid" />
                              </div>

                              <button type="button" onClick={e => {
                                  props.email_id ?
                                  window.location.href = `/edit-email-template/${item.id}/${props.email_id}`
                                  : window.location.href = `/edit-email-template/${item.id}`
                                }} 
                                className="btn btn-sm btn-outline-primary mt-3">Edit Template</button>
                            </div>
                          </div>
                        )
                      })}

                  </div>

                </div>
              </div>
              <div
                className="tab-pane fade show"
                id="email-temp-profile"
                role="tabpanel"
                aria-labelledby="email-temp-profile-tab"
              >
                <div className="standared-template">
                  <div className="row">
                    {loading ?
                      <div className="text-center col-md-12">
                        <span className="spinner-border" role="status" aria-hidden="true"></span>
                      </div>
                      : myTemplatesImage && 
                        myTemplatesImage.length > 0 ?
                          myTemplatesImage.map((item) => {
                            return (
                              <div key={item.id} className="my-2 col-md-2">
                                <div className="template-item-body text-center">
                                  <div 
                                    className={`template-item ${template && template.email_my_template_id === item.my_template_id && 'active-template'}`} 
                                    onClick={e => 
                                        changeValue({ id: item.id, image: item.template_image, email_my_template_id: item.my_template_id ,
                                        contents: item.contents
                                      })}
                                  >
                                    <img src={URL_S3 + 'image/email_template/' + item.template_image} alt="template-1" className="img-fluid" />
                                  </div>
                                  <p className="text-center">{item.name}</p>
                                  
                                </div>
                              </div>
                            )
                          })
                        :
                        <div className="text-center col-md-12">
                          <h4>No template found.</h4>
                        </div>
                      }

                  </div>

                </div>
              </div>
            </div>

          </div>
          <div className="modal-footer">
            <button type="button" className="px-5 m-1 btn btn-secondary radius-30" data-dismiss="modal">Close</button>
            <button type="button" className="px-5 m-1 btn btn-primary radius-30" onClick={handleSubmit} data-dismiss={submitClose && "modal"}>Save changes</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmailTemplate
